import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ folder, from, to }) =>
    present(
      repository
        .moveFolder(folder, from, to)
        .then(() => ({ folder, from, to }))
        .catch(() => Promise.reject({ folder, from, to })),
    );
}

export type { Interactor };

export { createInteractor };
